import Image from 'next/image';
import { RichText } from '~/components/RichText';

import { useCorporateSubFooter } from '~/hooks/useCorporateSubFooter';

const CorporateSubFooter = () => {
  const { data } = useCorporateSubFooter();
  if (!data) {
    return null;
  }

  const vectorBackground = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1760 111">
      <path
        fill="#fff"
        d="M0 93.3c1.2-.3 106.9-44.8 267.6-71.8C350.4 7.6 433.4.5 514.8.5H0v92.8ZM514.9.5c11.6 0 23.2.1 34.8.4 90.5 2.1 179.8 13.2 265 32.9l10.6 2.4c39.4 9.3 66.1 16.4 89.6 22.8 30.9 8.3 57.3 15.4 101.9 24.6 190.7 36.3 364.6 29.8 476.8 18 160.1-16.8 265.3-50.5 266.4-50.9V.5H514.9Z"
      />
    </svg>
  );

  return (
    <section className="mt-auto bg-neutral-50">
      {vectorBackground}
      <div className="mt-12 flex w-full max-w-7xl flex-col gap-12 px-4 pb-12 sm:mx-auto sm:flex-row sm:gap-8 md:pb-20">
        <div className="sm:w-1/4">
          <RichText content={data.column1} />
        </div>
        <div className="sm:w-1/4">
          <RichText content={data.column2} />
        </div>
        <div className="flex-grow sm:ml-auto sm:justify-items-center sm:self-center">
          <Image
            src={data.media.url}
            width={200}
            height={200}
            alt={data.media.description || ''}
            unoptimized // Will not render nice SVGs without this
          />
        </div>
      </div>
    </section>
  );
};
export default CorporateSubFooter;
